export const menuData = {
  mainMenu: [
    { id: 1, title: 'Welcome', path: '/', hasSubmenu: false },
    {
      id: 2,
      title: 'Our Practice',
      path: '/our-practice',
      hasSubmenu: true,
      submenu: [
        { id: 21, title: 'Dilip Dudhat, DMD', path: '/our-practice/dilip-dudhat-dmd' },
        { id: 22, title: 'Lemuel Pidlaoan (Dr. Lem)', path: '/our-practice/lemuel-pidlaoan-dr-lem' }
      ]
    },
    { id: 3, title: 'Payment Options', path: '/payment-options', hasSubmenu: false },
    { id: 4, title: 'Appointment Request', path: '/appointment-request', hasSubmenu: false },
    {
      id: 5,
      title: 'Cosmetic Dentistry',
      path: '/cosmetic-dentistry',
      hasSubmenu: true,
      submenu: [
        { id: 51, title: 'LUMINEERS®', path: '/cosmetic-dentistry/lumineers' },
        { id: 52, title: 'Invisalign®', path: '/cosmetic-dentistry/invisalign' },
        { id: 53, title: 'Dental Implants', path: '/cosmetic-dentistry/dental-implants' },
        { id: 54, title: 'Procera® Crowns', path: '/cosmetic-dentistry/procera-crowns' },
        { id: 55, title: 'Composite Fillings', path: '/cosmetic-dentistry/composite-fillings' },
        { id: 56, title: 'Porcelain Crowns (Caps)', path: '/cosmetic-dentistry/porcelain-crowns-caps' },
        { id: 57, title: 'Porcelain Fixed Bridges', path: '/cosmetic-dentistry/porcelain-fixed-bridges' },
        { id: 58, title: 'Porcelain Veneers', path: '/cosmetic-dentistry/porcelain-veneers' },
        { id: 59, title: 'Teeth Whitening', path: '/cosmetic-dentistry/teeth-whitening' }
      ]
    },
    { id: 6, title: 'Schedule Appointment', path: '/appointment-request', hasSubmenu: false },
    {
      id: 7,
      title: 'Procedures',
      path: '/procedures',
      hasSubmenu: true,
      isMegaMenu: true,
      submenu: [
        {
          id: 71, title: 'Cleanings & Prevention', path: '/procedures/cleanings-prevention', hasSubmenu: true,
          submenu: [
            { id: 711, title: 'Dental Exams & Cleanings', path: '/procedures/cleanings-prevention/dental-exams-cleanings' },
            { id: 712, title: 'Dental X-Rays', path: '/procedures/cleanings-prevention/dental-x-rays' },
            { id: 713, title: 'Digital X-Rays', path: '/procedures/cleanings-prevention/digital-x-rays' },
            { id: 714, title: 'Fluoride Treatment', path: '/procedures/cleanings-prevention/fluoride-treatment' },
            { id: 715, title: 'Home Care', path: '/procedures/cleanings-prevention/home-care' },
            { id: 716, title: 'How to Properly Brush & Floss', path: '/procedures/cleanings-prevention/how-to-properly-brush-floss' },
            { id: 717, title: 'Oral Hygiene Aids', path: '/procedures/cleanings-prevention/oral-hygiene-aids' }
          ]
        },
        {
          id: 72, title: 'Periodontal Disease', path: '/procedures/periodontal-disease', hasSubmenu: true,
          submenu: [
            { id: 721, title: 'What is Periodontal (Gum) Disease?', path: '/procedures/periodontal-disease/what-is-periodontal-gum-disease' },
            { id: 722, title: 'Diagnosis', path: '/procedures/periodontal-disease/diagnosis' },
            { id: 723, title: 'Treatment', path: '/procedures/periodontal-disease/treatment' },
            { id: 724, title: 'Maintenance', path: '/procedures/periodontal-disease/maintenance' },
            { id: 725, title: 'Causes of Periodontal Disease', path: '/procedures/periodontal-disease/causes-of-periodontal-disease' },
            { id: 726, title: 'Types of Periodontal Disease', path: '/procedures/periodontal-disease/types-of-periodontal-disease' },
            { id: 727, title: 'Signs & Symptoms', path: '/procedures/periodontal-disease/signs-symptoms-of-periodontal-disease' },
            { id: 728, title: 'Mouth - Body Connection', path: '/procedures/periodontal-disease/mouth-body-connection' },
            { id: 729, title: 'Periodontal Disease and Diabetes', path: '/procedures/periodontal-disease/periodontal-disease-and-diabetes' },
            { id: 7210, title: 'Heart Disease and Stroke', path: '/procedures/periodontal-disease/periodontal-disease-heart-disease-and-stroke' },
            { id: 7211, title: 'Periodontal Disease and Pregnancy', path: '/procedures/periodontal-disease/periodontal-disease-and-pregnancy' },
            { id: 7212, title: 'Periodontal Disease and Osteoporosis', path: '/procedures/periodontal-disease/periodontal-disease-and-osteoporosis' },
            { id: 7213, title: 'Respiratory Disease', path: '/procedures/periodontal-disease/periodontal-disease-and-respiratory-disease' }
          ]
        },
        {
          id: 73, title: 'Restorations', path: '/procedures/restorations', hasSubmenu: true,
          submenu: [
            { id: 731, title: 'Composite Fillings', path: '/procedures/restorations/composite-fillings' },
            { id: 732, title: 'Crowns (Caps)', path: '/procedures/restorations/crowns-caps' },
            { id: 733, title: 'Dentures & Partial Dentures', path: '/procedures/restorations/dentures-partial-dentures' },
            { id: 734, title: 'Fixed Bridges', path: '/procedures/restorations/fixed-bridges' },
            { id: 735, title: 'Inlay Restorations', path: '/procedures/restorations/inlay-restorations' },
            { id: 736, title: 'Onlay Restorations', path: '/procedures/restorations/onlay-restorations' },
            { id: 737, title: 'Root Canal Therapy', path: '/procedures/restorations/root-canal-therapy' }
          ]
        },
        {
          id: 74, title: 'Orthodontics', path: '/procedures/orthodontics', hasSubmenu: true,
          submenu: [
            { id: 741, title: 'What is Orthodontics?', path: '/procedures/orthodontics/what-is-orthodontics' },
            { id: 742, title: 'What is an Orthodontist?', path: '/procedures/orthodontics/what-is-an-orthodontist' },
            { id: 743, title: 'What is a Malocclusion?', path: '/procedures/orthodontics/what-is-a-malocclusion' },
            { id: 744, title: 'Who Can Benefit?', path: '/procedures/orthodontics/who-can-benefit-from-orthodontics' },
            { id: 745, title: 'Orthodontic Treatment (Braces)', path: '/procedures/orthodontics/orthodontic-treatment-braces' },
            { id: 746, title: 'Treatment Phases', path: '/procedures/orthodontics/orthodontic-treatment-phases' },
            { id: 747, title: 'Braces for Children', path: '/procedures/orthodontics/braces-for-children' },
            { id: 748, title: 'Braces for Adults', path: '/procedures/orthodontics/braces-for-adults' },
            { id: 749, title: 'Do Braces Hurt?', path: '/procedures/orthodontics/do-braces-hurt' },
            { id: 7410, title: 'Retainers', path: '/procedures/orthodontics/care-following-orthodontics-–-retainers' },
            { id: 7411, title: 'Invisalign®', path: '/procedures/orthodontics/invisalign' },
            { id: 7412, title: 'Why Straighten Teeth?', path: '/procedures/orthodontics/why-straighten-teeth' },
            { id: 7413, title: 'Orthodontic Dictionary', path: '/procedures/orthodontics/orthodontic-dictionary' }
          ]
        },
        {
          id: 75, title: 'Oral Surgery', path: '/procedures/oral-surgery', hasSubmenu: true,
          submenu: [
            { id: 751, title: 'Bone Grafting', path: '/procedures/oral-surgery/bone-grafting' },
            { id: 752, title: 'Wisdom Teeth Extractions', path: '/procedures/oral-surgery/wisdom-teeth-extractions' }
          ]
        },
        {
          id: 76, title: 'Periodontics', path: '/procedures/periodontics', hasSubmenu: true,
          submenu: [
            { id: 761, title: 'What is a Periodontist?', path: '/procedures/periodontics/what-is-a-periodontist' },
            { id: 762, title: 'When to See a Periodontist', path: '/procedures/periodontics/when-to-see-a-periodontist' },
            { id: 763, title: 'Antibiotic Treatment', path: '/procedures/periodontics/antibiotic-treatment' },
            { id: 764, title: 'Bone Grafting', path: '/procedures/periodontics/bone-grafting' },
            { id: 765, title: 'Bruxism', path: '/procedures/periodontics/bruxism' },
            { id: 766, title: 'Crown Lengthening', path: '/procedures/periodontics/crown-lengthening' },
            { id: 767, title: 'Gum & Jawbone Treatments', path: '/procedures/periodontics/gum-jawbone-corrective-treatments' },
            { id: 768, title: 'Gum Grafting', path: '/procedures/periodontics/gum-grafting' },
            { id: 769, title: 'Gum Recession', path: '/procedures/periodontics/gum-recession' },
            { id: 7610, title: 'Oral Cancer Exam', path: '/procedures/periodontics/oral-cancer-exam' },
            { id: 7611, title: 'Scaling & Root Planing', path: '/procedures/periodontics/periodontal-scaling-root-planing' },
            { id: 7612, title: 'Pocket Irrigation', path: '/procedures/periodontics/pocket-irrigation' },
            { id: 7613, title: 'Pocket Reduction Surgery', path: '/procedures/periodontics/pocket-reduction-surgery' },
            { id: 7614, title: 'Prophylaxis (Cleaning)', path: '/procedures/periodontics/prophylaxis-teeth-cleaning' },
            { id: 7615, title: 'Regenerative Procedures', path: '/procedures/periodontics/regenerative-procedures' },
            { id: 7616, title: 'Ridge Modification', path: '/procedures/periodontics/ridge-modification' },
            { id: 7617, title: 'Sinus Augmentation', path: '/procedures/periodontics/sinus-augmentation' },
            { id: 7618, title: 'Soft Tissue Grafting', path: '/procedures/periodontics/soft-tissue-grafting' }
          ]
        },
        {
          id: 77, title: 'Endodontics', path: '/procedures/endodontics', hasSubmenu: true,
          submenu: [
            { id: 771, title: 'Cracked Tooth', path: '/procedures/endodontics/cracked-tooth' },
            { id: 772, title: 'Root Canal Retreatment', path: '/procedures/endodontics/root-canal-retreatment' },
            { id: 773, title: 'Root Canal Therapy', path: '/procedures/endodontics/root-canal-therapy' }
          ]
        },
        {
          id: 78, title: 'Surgical Instructions', path: '/procedures/surgical-instructions', hasSubmenu: true,
          submenu: [
            { id: 781, title: 'Before General Anesthesia', path: '/procedures/surgical-instructions/before-general-anesthesia' },
            { id: 782, title: 'After Dental Implant Surgery', path: '/procedures/surgical-instructions/after-dental-implant-surgery' },
            { id: 783, title: 'After Tooth Extractions', path: '/procedures/surgical-instructions/after-tooth-extractions' }
          ]
        },
        { id: 79, title: 'Dental Anxiety and Fear', path: '/procedures/dental-anxiety-and-fear', hasSubmenu: false },
        { id: 80, title: 'Dental Emergencies', path: '/procedures/dental-emergencies', hasSubmenu: false }
      ]
    },
    {
      id: 8,
      title: 'Education and Resources',
      path: '/education-and-resources',
      hasSubmenu: true,
      submenu: [{ id: 81, title: 'Dental Videos', path: '/education-and-resources/dental-videos' }]
    },
    { id: 9, title: 'Contact Us', path: '/contact-us', hasSubmenu: false },
    { id: 10, title: 'Privacy Policy', path: '/privacy-policy', hasSubmenu: false },
    { id: 11, title: 'Terms and Conditions', path: '/terms-and-conditions', hasSubmenu: false }
  ]
};

export const practiceInfo = {
  name: 'P3 Dental of Northeast Philadelphia',
  tagline: 'Official Dentist of the Philadelphia Eagles',
  slogan: 'Caring for all of your dental needs',
  phone: '(215) 676-0222',
  email: 'p3dentalpc@gmail.com',
  address: { street: '10000 E Roosevelt Blvd', city: 'Philadelphia', state: 'PA', zip: '19116' },
  hours: [
    { day: 'Monday', open: '9:00 AM', close: '6:00 PM' },
    { day: 'Tuesday', open: '9:00 AM', close: '6:00 PM' },
    { day: 'Wednesday', open: '9:00 AM', close: '5:00 PM' },
    { day: 'Thursday', open: '9:00 AM', close: '6:00 PM' },
    { day: 'Friday', open: '9:00 AM', close: '3:00 PM' },
    { day: 'Saturday', open: '9:00 AM', close: '2:00 PM' },
    { day: 'Sunday', open: 'Closed', close: '' }
  ]
};

export const heroSlides = [
  { id: 1, title: "Walk In! You're Always Welcome!", highlight: '$0 Whiter, Healthier Cleanings!', description: 'For most insured patients. Call for details.', buttonText: 'Schedule Appointment', buttonLink: '/appointment-request', image: '/images/banner1.png' },
  { id: 2, title: 'A Philadelphia Tradition of Trusted Dental Excellence!', highlight: 'Invisalign Elite Preferred Provider', description: 'Official Dentist of the Philadelphia Eagles', buttonText: 'Meet Our Team', buttonLink: '/our-practice', image: '/images/banner2.jpg' },
  { id: 3, title: 'Comprehensive Care for Your Whole Family', highlight: '25+ Years of Excellence', description: 'From routine checkups to advanced cosmetic procedures', buttonText: 'Our Services', buttonLink: '/procedures', image: '/images/banner3.png' }
];

export const featureCards = [
  { id: 1, title: 'Family Safety Comes First', description: 'We maintain the highest standards of sterilization & patient safety.', image: '/images/card1.jpg' },
  { id: 2, title: 'Worry-Free Dental Care', description: 'We offer sedation options to make your visit comfortable.', image: '/images/card2.jpg', link: '/procedures/dental-anxiety-and-fear', linkText: 'Learn more →', highlighted: true },
  { id: 3, title: 'Affordable Dental Coverage', description: 'Flexible payment options. Insurance accepted. Financing available.', image: '/images/card3.jpg' }
];

export const services = [
  { id: 1, title: 'General Dentistry', description: 'Cleanings, exams, fillings, and preventive care.', icon: 'Stethoscope', link: '/procedures/cleanings-prevention' },
  { id: 2, title: 'Cosmetic Dentistry', description: 'Veneers, whitening, and smile makeovers.', icon: 'Sparkles', link: '/cosmetic-dentistry' },
  { id: 3, title: 'Restorations', description: 'Restore Your Smile.', icon: 'Users', link: '/procedures/restorations' },
  { id: 4, title: 'Orthodontics', description: 'Invisalign and braces to straighten teeth.', icon: 'Grid3X3', link: '/procedures/orthodontics' },
  { id: 5, title: 'Oral Surgery', description: 'Extractions, implants, and bone grafting.', icon: 'Scissors', link: '/procedures/oral-surgery' },
  { id: 6, title: 'Periodontics', description: 'Gum disease treatment and gum surgery.', icon: 'Heart', link: '/procedures/periodontics' }
];

export const getPageContent = (path) => {
  const pathParts = path.split('/').filter(Boolean);
  const title = pathParts[pathParts.length - 1]?.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ').replace(/\?/g, '') || 'Page';
  const category = pathParts.length > 1 ? pathParts[pathParts.length - 2]?.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : '';
  
  return {
    title,
    subtitle: category ? `${category} Services` : 'Dental Services',
    content: `At P3 Dental of Northeast Philadelphia, we provide comprehensive ${title.toLowerCase()} services. Our experienced dental team uses the latest techniques and technology to ensure you receive the best possible care.\n\nContact our office to learn more about ${title.toLowerCase()} or to schedule a consultation. We look forward to helping you achieve optimal oral health.`,
    image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=800&h=400&fit=crop'
  };
};
